import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../httpService/httpService";

export const fetchRejectedBrief = createAsyncThunk(
  "rejectedBrief/fetchRejectedBrief",
  async ({ page = 1, limit = 10, search }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get(
        "/fetch-all-rejected-briefs-admin",
        {
          params: {
            page,
            limit,
            search,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.data || response.status !== 200) {
        throw new Error("Failed to fetch pending briefs");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "An error occurred while fetching pending briefs"
      );
    }
  }
);

const fetchRejectedBriefSlice = createSlice({
  name: "rejectedBrief",
  initialState: {
    items: [],
    totalItems: 0,
    status: "idle",
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRejectedBrief.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchRejectedBrief.fulfilled, (state, action) => {
        console.log("inside fullfilled") ;
        state.status = "succeeded";
        state.items = action.payload.briefs;
        state.totalItems = action.payload.total;
        console.log("state.totalItems : "+ state.totalItems) ;
        state.loading = false;
      })
      .addCase(fetchRejectedBrief.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default fetchRejectedBriefSlice.reducer;
